<template>
  <div id="app">
    <transition name="fade" mode="out-in">
      <router-view></router-view>
    </transition>
  </div>
</template>

<script>
export default {
  methods: {
    startHacking () {
      
    }
  }
}
</script>

<style>
#app {
  font-family: Helvetica, sans-serif;
}
body{
  margin: 0;
}
</style>



// WEBPACK FOOTER //
// src/App.vue